import React from "react";
import PropTypes from "prop-types";
import ModalAlert from "../ModalAlert";
import ModalOverlay from "../ModalOverlay";
import ModalLoading from "../ModalLoading";
import ModalFull from "../ModalFull";

const ModalController = props => {
  const { type, payload, onClose } = props;
  let modal = null;
  // console.log("modaltype", type);
  switch (type) {
    case "aside":
      modal = <ModalOverlay {...payload} _onClose={onClose} transparent />;
      break;
    case "overlay":
      modal = <ModalOverlay {...payload} _onClose={onClose} />;
      break;
    case "alert":
      modal = <ModalAlert {...payload} _onClose={onClose} />;
      break;
    case "loading":
      modal = <ModalLoading {...payload} _onClose={onClose} />;
      break;
    case "full":
      modal = <ModalFull {...payload} _onClose={onClose} />;
      break;
    default:
      break;
  }
  return modal;
};

ModalController.propTypes = {
  onClose: PropTypes.func.isRequired,
  type: PropTypes.string,
  payload: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};

ModalController.defaultProps = {
  type: null,
  payload: {}
};

export default ModalController;



// WEBPACK FOOTER //
// ./src/components/ModalController/ModalController.js